import { Box, Flex, Text } from "@chakra-ui/react";
import type { LucideIcon } from "lucide-react";
import { Panel } from "./Panel";
import { StatusBadge } from "./StatusBadge";
import { palette } from "./theme";

export type KpiCardProps = {
  title: string;
  value: string;
  badge: string;
  note?: string;
  color: string;
  icon: LucideIcon;

  help?: React.ReactNode;
};

export const KpiCard = ({
  title,
  value,
  badge,
  note,
  color,
  icon: Icon,
  help,
}: KpiCardProps): JSX.Element => (
  <Panel title={title} help={help}>
    <Flex justify="space-between" align="flex-start" gap={3}>
      <Box>
        <Text
          fontSize="24px"
          lineHeight="1"
          fontWeight="700"
          color={palette.text}
          mb={3}
        >
          {value}
        </Text>
        <StatusBadge color="blue">{badge}</StatusBadge>
        {note && (
          <Text color={palette.muted} fontSize="11px" mt={2}>
            {note}
          </Text>
        )}
      </Box>
      <Flex
        w="32px"
        h="32px"
        borderRadius="md"
        align="center"
        justify="center"
        bg={palette.soft}
        color={color}
        flex="none"
      >
        <Icon size={17} />
      </Flex>
    </Flex>
  </Panel>
);
